import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Bankingcs2 = () => {
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/financeimg1.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
          American Credit Union smashes silos with ServiceNow ITBM
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      <Typography variant="body1" sx={{ color: "#333", fontSize: "18px" }}>
      A U.S.-based credit union, with a proud culture of unwavering commitment to its members and employees, sought to boost the innovation and agility needed to respond to changing expectations.     </Typography>
      <Typography variant="body1" sx={{ mt: 2, color: "#333", fontSize: "18px"  }} mb={8}>
      It began cultivating a cohesive, well-structured digital footprint and implementing ServiceNow’s IT Business Management (ITBM) solution to break down siloes and launch a winning cross-functional strategy for the long term.   </Typography>
        
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Customers are no longer comparing banks to other banks. They’re comparing banks to every other service they use, from Amazon to Uber. Financial organizations that can’t match the speed and ease of use of these top players will inevitably fall behind. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        And industry leaders know that digitally transforming to enable seamless collaboration from the front to the back office is the key to delivering stellar customer experience. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        A large credit union, shackled by silos, knew it had to address this new reality. Three distinct areas that handled project management operated semi-independently and used their own systems and processes. This meant the organization lacked true, enterprise-wide visibility, leaving customers dissatisfied when problem resolution required the help of multiple departments. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Additionally, internal stakeholders lacked the visibility necessary to monitor demand for products and services within IT. They also had no system of record to track ideas, leaving employees in the dark once a submission was made. </Typography>
      
        
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Aligning the entire organization on the same platform would streamline processes, reduce entropy and provide the enterprise-wide visibility needed to accurately forecast demand and allow staff to work more efficiently for the good of the customer.  </Typography>



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={14}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Transforms and improves people and process functions",
                "Allows IT management and staff to work more efficiently"
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Optimizes and streamlines demand approval flows and assessment rules to improve operational health, project prioritization, and process and planning activities"
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


{/* banner Section */}
<Box
        sx={{
          height: "60vh",
          backgroundImage: `url('/image/bankimg2.jpg')`, 
          backgroundSize: "cover",
        //  backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
          backgroundPosition: "center 10%", // move image down
          
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "22px", md: "42px" }}}>
         
          The credit union successfully overcame the critical challenge of disjointed processes by centralizing and streamlining demand approvals within ServiceNow ITBM.  </Typography>
        </Box>
      </Box>




      <Container sx={{ py: 10 }}>
      
       
      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Solution
          </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        ServiceNow: One platform to bring together the entire organization
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The credit union sought a platform that could offer the functionality to serve as its enterprise backbone. ServiceNow’s unique ability to connect and streamline siloed business processes and provide accurate reporting made the platform a no-brainer for the organization. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        The business had used Tech Informatic Solutions as its trusted ServiceNow partner since the beginning of its digital transformation journey, starting with an advisory project that evaluated the current operating state and solidified goals.  </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Once a roadmap was clearly defined and a foundational IT Software Management (ITSM) implementation was successfully completed, the company established a strong foundation for future platform expansion. Next, it set its sights on drastically improving how it functioned from a people and process point of view. The solution was ServiceNow ITBM, which would cover:  </Typography>
        

        <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={14}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Idea and demand management",
                "Project portfolio management",
                 "Timecard management",
                  "Resource management"
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Labor capitalization",
                "Multiple integrations",
                 "Custom reports",
                  "Data migration"
                
                ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


      <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
      The teams started with a series of workshops and training that helped establish ownership and secure buy-in from their various departments. The participation of their wider user base was crucial, with a few key players at the credit union stepping into the role of subject-matter experts who now manage and maintain the platform moving forward. </Typography>
       



        <Typography variant="h5" fontWeight="bold" mb={3}>
        Looking to the future
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The business has successfully overcome the critical challenge of disjointed processes by centralizing and streamlining demand approvals within ServiceNow ITBM.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        It now has a defined process that automates manual steps (like email) and provides a clearly defined chain of communication. The organization can assign tasks directly, bypassing the involvement of multiple other parties. It also can assess, track, manage, and accurately forecast demand for products and services moving forward.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        Unlike other solutions, ServiceNow provides a single system of record, allowing data and processes to be shared across all ServiceNow applications. The footprint now spans more than one department, meaning it is well on its way to breaking down silos and enabling true top-down visibility. And additional project management organizations can leverage the framework.</Typography>
        
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Recognizing that meaningful digital transformation is not a one-and-done process, the credit union is hard at work navigating the rest of its strategic roadmap, with governance, risk and compliance, SecOps and HR service delivery next on the docket.</Typography>

</Container>



<Footer/>
    </Box>


  );
};

export default Bankingcs2;
